import { useRouter } from 'next/router';
import { useState } from 'react';
import Layout from '../components/Layout'

const LeadPage = () => {

  const router = useRouter();
  const [errors, setError] = useState<any>({})
  const [formData, setData] = useState<any>({})

  const validate = () => {
    let error: any = {};
    let errorCount = 0;
    if (typeof formData.first_name == 'undefined' || formData.first_name.trim() == '') {
      error['first_name'] = true
      errorCount++;
    }
    if (typeof formData.last_name == 'undefined' || formData.last_name.trim() == '') {
      error['last_name'] = true
      errorCount++;
    }
    if (typeof formData.phone_no == 'undefined' || formData.phone_no.trim() == '' || formData.phone_no.length < 10) {
      error['phone_no'] = true
      errorCount++;
    }
    if (typeof formData.email == 'undefined' || formData.email.trim() == '') {
      error['email'] = true
      errorCount++;
    }
    if (typeof formData.address == 'undefined' || formData.address.trim() == '') {
      error['address'] = true
      errorCount++;
    }
    if (typeof formData.contact_preference == 'undefined' || formData.contact_preference.trim() == '') {
      error['contact_preference'] = true
      errorCount++;
    }
    if (typeof formData.installation_address == 'undefined' || formData.installation_address.trim() == '') {
      error['installation_address'] = true
      errorCount++;
    }
    if (typeof formData.house_type == 'undefined' || formData.house_type.trim() == '') {
      error['house_type'] = true
      errorCount++;
    }
    setError(error);
    return errorCount ? true : false;
  }

  const submitLead = (e: any) => {
    e.preventDefault()
    const isError = validate()
    console.log('isError', isError, 'formData', formData)
  }
  const gotoPrev = () => {
    router.back()
  }

  const setFormData = (e: any) => {
    let data: any = formData
    data[e.target.name] = e.target.value
    setData(data)
    validate()
  }

  return (
    <Layout title="Lead">
      <div className="lead relative flex-col-reverse md:flex-row">
        <div className="block md:hidden mobile-view-banner">

        </div>
        <div className="hidden md:block fixed top-20 left-0 w-10 lg:w-16 xl:w-20 z--1 2xl:w-full">
          <img src="/images/blue-strip.png" alt="" />
        </div>
        <div className=" container m-auto">
          <div className="home__wrap p-4 xxs:p-6 md:pl-12  w-full md:w-3/5 flex flex-col items-center xl:pl-28 xd:pl-0 xl:pt-10">
            <div className="w-full">
              <h2 className="text-2xl xxs:text-4xl xl:text-5xl font-primaryBold text-titleColor lg:leading-heading">
                Your Contact Information
              </h2>

              <form className="py-4 w-full 2xl:w-4/5" onSubmit={submitLead} autoComplete="off">
                <div className="grid grid-cols-1 gap-y-2 sm:grid-cols-2 sm:gap-y-4 sm:gap-x-6">
                  <div>
                    <input type="text" placeholder="First Name" onInput={setFormData} name="first_name" title="Enter First Name" className="  p-3 border border-gray-300 rounded-md w-full placeholder-current text-bodyColor text-sm" />
                    {errors.first_name ? <span className="form-error">Enter first name</span> : null}
                  </div>
                  <div>
                    <input type="text" placeholder="Last Name" onChange={setFormData} name="last_name" title="Enter Last Name" className="  p-3 border border-gray-300 rounded-md w-full placeholder-current text-bodyColor text-sm" />
                    {errors.last_name ? <span className="form-error">Enter last name</span> : null}
                  </div>
                  <div>
                    <input type="tel" pattern="^\d{3}\d{3}\d{4}$" placeholder="Phone No." onChange={setFormData} name="phone_no" title="Enter Phone No" className="  p-3 border border-gray-300 rounded-md w-full placeholder-current text-bodyColor text-sm" />
                    {errors.phone_no ? <span className="form-error">Enter Phone No.</span> : null}
                  </div>
                  <div>
                    <input type="email" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,14}$" placeholder="E-mail" onChange={setFormData} name="email" title="Enter Email" className="  p-3 border border-gray-300 rounded-md w-full placeholder-current text-bodyColor text-sm" />
                    {errors.email ? <span className="form-error">Enter E-mail</span> : null}
                  </div>
                  <div>
                    <input type="text" placeholder="Street Address" onInput={setFormData} name="address" title="Enter Street Address" className="  p-3 border border-gray-300 rounded-md w-full placeholder-current text-bodyColor text-sm" />
                    {errors.address ? <span className="form-error">Enter street address</span> : null}
                  </div>
                  <div>
                    <select
                      id="contact_preference"
                      className="p-3 pr-8 border border-gray-300 rounded-md w-full placeholder-current text-bodyColor text-sm"
                      name="contact_preference"
                      onChange={setFormData}
                    >
                      <option value="">Contact Preference</option>
                      <option value="email">E-mail</option>
                      <option value="Sms">Sms </option>
                    </select>
                    {errors.contact_preference ? <span className="form-error">Select contact preference</span> : null}
                  </div>
                  <div>
                    <select
                      id="installation_address"
                      name="installation_address"
                      className="p-3 pr-8 border border-gray-300 rounded-md w-full placeholder-current text-bodyColor text-sm"
                      title="Installation Type"
                      onChange={setFormData}
                    >
                      <option value="">Installation Type</option>
                      <option value="Roof">Roof</option>
                      <option value="Solar">solar </option>
                      <option value="Battery">Battery</option>
                    </select>
                    {errors.installation_address ? <span className="form-error">Select installation address</span> : null}
                  </div>
                  <div>
                    <select
                      id="house_type"
                      name="house_type"
                      className="p-3 pr-8 border border-gray-300 rounded-md w-full placeholder-current text-bodyColor text-sm"
                      onChange={setFormData}
                    >
                      <option value=""> Are you building a new home at this address? </option>
                      <option value="No">No</option>
                      <option value="Yes"> Yes</option>
                    </select>
                    {errors.house_type ? <span className="form-error">Select building type</span> : null}
                  </div>
                  
                  

                </div>
                <p className="text-xs text-bodyColor mt-4">
                  By clicking submit, you consent to receive emails, text messages and phone calls at any email address and phone number you provide, even if the number is a wireless number. You agree that such calls and texts may be made using automated technology and that you are not required to provide consent to these calls to make a purchase from us.
                  </p>
                <div className="mt-4 grid  gap-y-2 grid-cols-2 xxs:gap-y-4 xxs:gap-x-6">
                  <div className="flex flex-row items-center xxs:justify-end">
                    <button type="button" onClick={gotoPrev} className="block p-3 px-8 rounded-md bg-bodyColor bg-opacity-10 text-titleColor text-sm font-primaryRegular uppercase text-center">
                      Back
                </button>
                  </div>
                  <div className="flex flex-row items-center justify-start">
                    <button className="block p-3 px-8 rounded-md bg-primary text-white text-sm font-primaryRegular uppercase text-center">
                      Submit
                </button>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
        <div className="hidden md:block right__image md:fixed top-20 right-0 z--1 w-1/4 2xl:w-2/5">
        </div>
      </div>
    </Layout >
  )
}

export default LeadPage
